var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgToggle = function SvgToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.999 2.083A.917.917 0 002.082 3v10c0 .506.41.916.917.916h1.75V2.083h-1.75zm3.25 0v11.833h6.75c.506 0 .916-.41.916-.916V3A.917.917 0 0013 2.083H6.25zm-3.25 13.333h10A2.417 2.417 0 0015.415 13V3A2.417 2.417 0 0013 .583H3A2.417 2.417 0 00.582 3v10a2.417 2.417 0 002.417 2.416zm7.197-9.613a.75.75 0 10-1.06 1.06L10.27 8 9.135 9.136a.75.75 0 001.06 1.06l1.667-1.666a.75.75 0 000-1.06l-1.666-1.667z",
    fill: "#48525C"
  })));
};
export default SvgToggle;